module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/helpers/SdgIcons/assets/sdg8-832d30d9804412dfc62798b9c663b08b.svg";